import { Link } from 'react-router-dom';
import { siteConfig } from '@/config/site';

function Hero() {
  return (
    <section className="relative flex min-h-[560px] w-full items-center overflow-hidden md:min-h-[620px]">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=stylish%20abstract%20anime%20manga%20background%20with%20dynamic%20brush%20strokes%20and%20floating%20ink%20swirls%20in%20warm%20vermilion%20orange%20and%20cream%20tones%2C%20artistic%20illustration%2C%20sense%20of%20energy%20and%20storytelling%2C%20soft%20depth%2C%20editorial%20hero%20banner&width=1600&height=900&seq=hero-bg-manga-01&orientation=landscape')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/30 to-foreground-950/60"></div>
      <div className="relative mx-auto w-full max-w-7xl px-4 py-20 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur">
          <i className="ri-fire-fill text-accent-500"></i>
          海量在线漫画 · 每日更新
        </span>
        <h1 className="mx-auto mt-6 max-w-3xl font-heading text-4xl font-bold leading-tight text-background-50 md:text-5xl">
          {siteConfig.name} - 按题材、类型、标签轻松找漫画
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          完结漫画与连载中漫画分门别类，人气分类直接推荐。无论是热血冒险、玄幻修仙还是恋爱甜宠，总有一部适合你的漫画。
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/category"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-8 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-compass-3-line mr-2 text-base"></i>
            浏览全部漫画
          </Link>
          <Link
            to="/category?status=serializing"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md border border-background-50/60 bg-foreground-950/20 px-8 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-foreground-950/40 sm:w-auto"
          >
            <i className="ri-flashlight-line mr-2 text-base"></i>
            看连载中漫画
          </Link>
        </div>
        <div className="mx-auto mt-10 flex flex-wrap items-center justify-center gap-6 text-background-100">
          <span className="text-sm"><strong className="text-xl font-bold text-background-50">2000+</strong> 部漫画</span>
          <span className="h-4 w-px bg-background-50/40"></span>
          <span className="text-sm"><strong className="text-xl font-bold text-background-50">6</strong> 大题材分类</span>
          <span className="h-4 w-px bg-background-50/40"></span>
          <span className="text-sm"><strong className="text-xl font-bold text-background-50">10万+</strong> 每日阅读</span>
        </div>
      </div>
    </section>
  );
}

export default Hero;